import React, { useContext, useEffect, useState } from "react";
import { Toast, ToastContainer } from 'react-bootstrap';
 
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function Toasts({ doRead }) {

    useEffect(() => { 
            lastMessage();  
    }, [doRead]);

    const [list, setList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isPosting, setIsPosting] = useState(false);
 

    const lastMessage = async () => {
        
        setIsLoading(true);
        await noronServices.LastMessage({
            from: 0,
            pageSize: 10,
            where: "",
            order: ""
        })
            .then(({ data }) => {
                setIsLoading(false); 
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    setList([]);
                    return
                }
                const items = data.payload.list.map(x => ({ ...x, show: true }));
                setList(items); 
            })
            .catch(err => {
                setIsLoading(false); 
            });
    }

    const doCloseMessage = async (item, index) => {        
        setIsPosting(true);
        await noronServices.ReadMessage(item.id)
            .then(({ data }) => {
                setIsPosting(false); 
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setList(prev => prev.map((x, i) => i === index ? { ...x, show: false } : x));
            })
            .catch(err => {
                setIsPosting(false); 
            });
    }



    return (
        <> 
            <ToastContainer className="p-3" position="bottom-center">
                {!isLoading && list.map((item, index) => (
                    <Toast onClose={() => doCloseMessage(item, index)} show={item.show} bg="Light" key={"toast" + index} >
                        <Toast.Header>
                            <strong className="me-auto">{item.title1}</strong>
                            <small>{item.title2}</small>
                        </Toast.Header>
                        <Toast.Body>{item.message}</Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>

        </>
    )
}